import * as React from 'react';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
var BaukastenMenu = function () {
  var _a, _b, _c, _d, _e, _f;
  var _g = useState('closed'),
    position = _g[0],
    setPosition = _g[1];
  function togglePosition(evt) {
    evt.stopPropagation();
    if (position === 'closed') {
      setPosition('open');
    } else {
      setPosition('closed');
    }
  }
  var hasMenu = ((_a = window.layoutSettings.content.extraSubPages) === null || _a === void 0 ? void 0 : _a.livecam) || ((_b = window.layoutSettings.content.extraSubPages) === null || _b === void 0 ? void 0 : _b.video) || ((_c = window.layoutSettings.content.extraSubPages) === null || _c === void 0 ? void 0 : _c.phonesex);
  if (!hasMenu) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: 'hamburgler',
    onClick: togglePosition,
    className: position
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBars
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes
  })), /*#__PURE__*/React.createElement("div", {
    id: 'categoryNav',
    className: 'c-navigation kit-navigation ' + position
  }, /*#__PURE__*/React.createElement("div", {
    className: 'prodwidth center l-container h-center'
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(NavLink, {
    className: 'c-navigation__link',
    activeClassName: 'active c-navigation__link--active',
    to: {
      pathname: '/'
    },
    isActive: function (match, location) {
      return !!location.pathname.match(/^\/(seite\/\d+\/)?$/);
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Telefon-Cam"), ((_d = window.layoutSettings.content.extraSubPages) === null || _d === void 0 ? void 0 : _d.livecam) && /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    className: 'c-navigation__link',
    activeClassName: 'active c-navigation__link--active',
    to: {
      pathname: '/chatcam/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Chat-Cam"), ((_e = window.layoutSettings.content.extraSubPages) === null || _e === void 0 ? void 0 : _e.video) && /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    className: 'c-navigation__link',
    activeClassName: 'active c-navigation__link--active',
    to: {
      pathname: '/kaufvideos/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Kaufvideos"), ((_f = window.layoutSettings.content.extraSubPages) === null || _f === void 0 ? void 0 : _f.phonesex) && /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    className: 'c-navigation__link',
    activeClassName: 'active c-navigation__link--active',
    to: {
      pathname: '/telefonsex/'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faChevronRight
  }), " Telefonsex")))));
};
export default BaukastenMenu;